import { render, staticRenderFns } from "./onlineTerminal.vue?vue&type=template&id=2983acdd&scoped=true&"
import script from "./onlineTerminal.vue?vue&type=script&lang=js&"
export * from "./onlineTerminal.vue?vue&type=script&lang=js&"
import style0 from "./onlineTerminal.vue?vue&type=style&index=0&id=2983acdd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2983acdd",
  null
  
)

export default component.exports